interface LogoProps {
  compact?: boolean
}

export function Logo({ compact = false }: LogoProps) {
  return (
    <a className="brand" href="#top" aria-label="zozinimg 홈">
      <span className="brand-mark" aria-hidden="true">
        <i />
        <b>z</b>
      </span>
      <span className="brand-name">
        zozin<b>img</b>
      </span>
      {!compact && <span className="brand-tag">작업대</span>}
    </a>
  )
}
